import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  const situations = ['Te despiertas hinchada aunque no hayas comido "mal" el día anterior', 'Intentas dejar el pan pero a las 11 de la mañana ya estás pensando en él', 'Compraste pan sin gluten industrial y sabe a cartón mojado', 'En las comidas familiares o con amigos acabas comiendo lo de siempre "porque no hay otra opción"', 'Llevas semanas inflamada y no sabes exactamente qué es lo que te hace daño', 'Tienes niebla mental después de comer pero nadie te lo explica', 'Gastas una fortuna en productos "sin gluten" que no te convencen y siguen inflamándote'];
  return <Section variant="alt" data-id="element-145" data-mp="3nd7i3pmas8tb">
      <div className="text-brand-secondary font-heading font-bold text-xs uppercase tracking-[0.15em] text-center mb-3" data-id="element-146" data-mp="3nbcvm6vdo8n4">
        ¿Te reconoces?
      </div>
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-10 text-brand-title max-w-2xl mx-auto leading-tight" data-id="element-147" data-mp="1u1txcpuxycfa">
        Si dices sí a alguna de estas situaciones, este sistema es para ti.
      </h2>

      <div className="grid md:grid-cols-2 gap-3.5 max-w-3xl mx-auto mb-10" data-id="element-148" data-mp="23r58ei1e1r5t">
        {situations.map((situation, i) => <div key={i} className="bg-white border border-brand-border rounded-xl p-4 flex items-start gap-3 shadow-card" data-id="element-149" data-mp="1g2lwztn1ky9i" data-mpi={i}>
            <span className="w-5 h-5 rounded-full border-2 border-brand-primary shrink-0 mt-0.5" data-id="element-150" data-mp="1b4kd56hskuwz" />
            <span className="font-body text-brand-text text-sm leading-snug" data-id="element-151" data-mp="1p3sikh4jsz9m">
              {situation}
            </span>
          </div>)}
      </div>

      <div className="text-center" data-id="element-152" data-mp="30h4n6u84tlwu">
        <button onClick={scrollToPricing} className="font-display text-lg md:text-xl text-brand-title italic hover:text-brand-primary transition-colors" data-id="element-153" data-mp="30g2znq9xj6y8">
          Y tú mereces mucho más que eso →
        </button>
      </div>
    </Section>;
}